// extracted by mini-css-extract-plugin
export var actions = "_tj-4";
export var item = "_tj-1";
export var price = "_tj-3";
export var quantity = "_tj-2";
export var table = "_tj-0";